import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { popExchangeSession } from '../../lib/popApi';
import { usePoPAuth } from '../../context/PoPAuthContext';
import { Loader2 } from 'lucide-react';

const PoPAuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = usePoPAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = /session_id=([^&]+)/.exec(hash);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate('/pop', { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await popExchangeSession(sessionId);
        setUser(res.user);
        if (location.pathname === '/diagnostic/auth/callback') {
          navigate('/diagnostic', { replace: true });
          return;
        }
        // Strip hash from URL and route based on onboarding state
        if (!res.user || res.user.role === 'unassigned') {
          navigate('/pop/onboarding', { replace: true, state: { user: res.user } });
        } else if (res.user.role === 'super_admin') {
          navigate('/pop/admin', { replace: true, state: { user: res.user } });
        } else {
          navigate('/pop/dashboard', { replace: true, state: { user: res.user } });
        }
      } catch (e) {
        navigate('/pop?error=auth', { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center text-white">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-amber-300 mx-auto mb-3" />
        <p className="text-sm text-white/60">Signing you into SAMANVAI PoP Exchange…</p>
      </div>
    </div>
  );
};

export default PoPAuthCallback;
